import { render, staticRenderFns } from "./mateBill.vue?vue&type=template&id=ff9fb586&scoped=true&"
import script from "./mateBill.vue?vue&type=script&lang=js&"
export * from "./mateBill.vue?vue&type=script&lang=js&"
import style0 from "./mateBill.vue?vue&type=style&index=0&id=ff9fb586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9fb586",
  null
  
)

export default component.exports